import { getObjectWithSelector } from '../../../functions/objectFunctions/getObjectWithSelector';
import { updateObjectNestedProperties } from '../../../functions/objectFunctions/updateObjectNestedProperties';
import { useElements, useScene } from '../../../hooks';
import { LauncherElement } from '../../../types/launcherElement';
import { SelectInput } from './selectInput/SelectInput';

export const VisibilityInput = ({
  variant,
  tab,
}: {
  variant?: string;
  tab?: string;
}) => {
  const scene = useScene();
  const lastSelectedElementID = scene.selectedElementIDs.slice(-1)[0];
  const [selectedElement, setSelectedElement] = useElements<LauncherElement>({
    id: lastSelectedElementID,
  });

  let selector: string = 'props.class';
  if (variant && tab) {
    selector = `props.class.variants.${variant}.${tab}`;
  }

  const display = getObjectWithSelector(selectedElement, `${selector}.display`);

  return (
    <SelectInput
      options={[
        { value: undefined, label: '' },
        { value: 'flex', label: 'Visible' },
        { value: 'none', label: 'Hidden' },
      ]}
      key={`${lastSelectedElementID}-${variant}-display-${tab}-input`}
      id={`${lastSelectedElementID}-${variant}-display-${tab}-input`}
      label="Visibility"
      value={display}
      onChange={(inputValue: string) =>
        setSelectedElement((prev) =>
          updateObjectNestedProperties(prev, {
            [`${selector}.display`]: inputValue,
          })
        )
      }
    />
  );
};
